'use client'

import DocPage from './DocPage'

export default function Service({ vendor }: { vendor?: any }) {
  return (
    <DocPage
      vendor={vendor}
      pageKey="service"
      title="Үйлчилгээний нөхцөл"
      description="Энэхүү дэлгүүрийн платформыг ашиглах хэрэглэгч болон үйлчилгээ үзүүлэгчийн хооронд үүсэх харилцааг зохицуулна. Бүртгэл үүсгэх болон захиалга өгөхөөс өмнө нөхцөлтэй танилцана уу."
      htmlContent={vendor?.terms?.service}
      emptyMessage="Одоогоор үйлчилгээний нөхцөл нэмэгдээгүй байна."
    />
  )
}
